import { render, staticRenderFns } from "./RegistrationsList.vue?vue&type=template&id=7e163205"
import script from "./RegistrationsList.vue?vue&type=script&lang=js"
export * from "./RegistrationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports